import React from 'react';

import styled from '@emotion/styled';
import { fontSizesNamed } from '@opendoor/bricks/theme/eero';
import { media } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';
import classNames from 'classnames';

export declare interface IGenericErrorProps {
  errorContent?: string | React.ReactNode;
  showBorder?: boolean;
  headerContent?: string;
}

const HeaderContent = styled.h1({
  wordBreak: 'break-word',
  fontSize: `${fontSizesNamed.s3}`,

  [media.largerThan.MD]: {
    fontSize: `${fontSizesNamed.s5}`,
  },
});

export default class GenericError extends React.PureComponent<IGenericErrorProps> {
  public static defaultProps: Partial<IGenericErrorProps> = {
    showBorder: true,
  };

  public render() {
    const { errorContent, showBorder, headerContent } = this.props;
    const errorEmail = 'contact@opendoor.com';

    return (
      <div className={classNames('box', { 'no-shadow': !showBorder })}>
        <section className="text-center ">
          <HeaderContent>
            {headerContent ? headerContent : 'Oops, something went wrong'}
          </HeaderContent>
          {errorContent ? (
            errorContent
          ) : (
            <p>
              It looks like we ran into an issue. Please try again.
              <br />
              Email us at <a href={`mailto:${errorEmail}`}>{errorEmail}</a> if the problem persists.
            </p>
          )}
        </section>
      </div>
    );
  }
}
